module.exports = __webpack_public_path__ + "static/img/021_4.26a82e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_4.jpg
// module id = 41of
// module chunks = 1